import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../../../Context/GlobalContext";
import { AddressBookSVG } from "../../../../../assets/imageImport";
import { isValidArray, scrollToTop } from "../../../../../Layout/Common/common";
import { useGlobalFunction } from "../../../../../Context/GlobalFunctionContext";
import { v4 as uuidv4 } from "uuid";
import { convertAddressBookFormat, convertAddressBookJson } from "../../../checkoutFunction";
import { AddressBookCardSkeleton } from "../../../../../Skeleton/checkout/addressBookCardSkeleton";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { NoAddressBook } from "../../../../MyAccount/addressBook/noAddressBook";

export const AddressBookList = ({ onEdit, onSelect, onReset, onCancel }) => {
  const { getMyAddressBook } = useGlobalFunction();
  const pickaddressref = useRef();
  const [selectedId, setSelectedId] = useState(null);
  const { addressList, setAddressList, shippingAddressOriginal, selectedAddressId, setSelectedAddressId } =
    useContext(GlobalContext);

  useEffect(() => {
    getAddressBook();
    scrollToTop();
  }, []);

  useEffect(() => {
    if (selectedAddressId) {
      setSelectedId(selectedAddressId);
    } else {
      setSelectedId(null);
    }
  }, [selectedAddressId]);

  const getAddressBook = async () => {
    var response = await getMyAddressBook();
    if (response) {
      {
        setAddressList(response);
      }
    } else setAddressList([]);
  };

  const handleAddNewClick = () => {
    onEdit(convertAddressBookJson({}));
  };

  return (
    <Fragment>
      <div className="col-lg-12">
        {addressList == null ? (
          <AddressBookCardSkeleton count={2} />
        ) : isValidArray(addressList) ? (
          <TransitionGroup className={"addressBook-group"}>
            {addressList.map((row, index) => {
              const item = convertAddressBookJson(row);
              const uid = uuidv4();
              return (
                <CSSTransition key={item.id} timeout={500} classNames="fade">
                  <div className="addressbook-list" id={uid} key={item.id}>
                    <div className="addressbook-listLft">
                      <div className="form-check custom-check signupConfirm">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="myAddressBook"
                          id={`saveAdd-bookForm-${item.id}`}
                          checked={selectedId === item.id}
                          onClick={() => {
                            if (selectedId === item.id) {
                              setSelectedId(null);
                              onReset();
                            } else {
                              setSelectedId(item.id);
                              onSelect(item);
                            }
                          }}
                        />
                      </div>
                      <div className="listedAddress">
                        <label htmlFor={`saveAdd-bookForm-${item.id}`}>
                          <address className="text-dark mb-0">
                            <b>{item.shipTo}</b>
                            <br />
                            {item.attentionTo}
                            <br />
                            {item.address1},{item.address2 && item.address2 + ","}
                            {item.suburb},{item.state}-{item.postCode} ,{item.country},
                            <br /> Phone Number :{item.phone}
                            <br />
                            Delivery Type: {item.addressType},
                            <br />
                            Signature Required:
                            {item.signRequired == true ? "Yes" : "No"}
                            <br />
                          </address>
                        </label>
                      </div>
                    </div>
                    <div className="addressbook-listRht">
                      <button
                        type="button"
                        onClick={() => {
                          onEdit(item);
                        }}
                        className="a-tag-button text-decoration-underline fs-14"
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                </CSSTransition>
              );
            })}{" "}
          </TransitionGroup>
        ) : (
          <NoAddressBook handleAddNewClick={handleAddNewClick} />
        )}
      </div>
      {shippingAddressOriginal && (
        <div className="col-lg-12 mt-4">
          <strong>Default:</strong>
          <div className={"addressBook-group"}>
            <div
              className="addressbook-list"
              id={`original-${shippingAddressOriginal.id}`}
              key={shippingAddressOriginal.id}
            >
              <div className="addressbook-listLft">
                <div className="form-check custom-check signupConfirm">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="myAddressBook"
                    id={`saveAdd-bookForm-original`}
                    onClick={onReset}
                    checked={selectedId === null}
                    readOnly
                  />
                </div>
                <div className="listedAddress">
                  <label htmlFor={`saveAdd-bookForm-original`}>
                    <address className="text-dark mb-0">
                      <b>{shippingAddressOriginal.shipTo}</b>
                      <br />
                      {shippingAddressOriginal.shipAttention}
                      <br />
                      {shippingAddressOriginal.shipAddress1},
                      {shippingAddressOriginal.shipAddress2 && shippingAddressOriginal.shipAddress2 + ","}
                      {shippingAddressOriginal.suburb},{shippingAddressOriginal.shipState}-
                      {shippingAddressOriginal.shipZip} ,{shippingAddressOriginal.shipCountry},
                      <br /> Phone Number :{shippingAddressOriginal.shipPhone}
                      <br />
                      Delivery Instruction:
                      {shippingAddressOriginal.deliveryInstruction
                        ? shippingAddressOriginal.deliveryInstruction
                        : "N/A"}
                      <br />
                    </address>
                  </label>
                </div>
              </div>
              <div className="addressbook-listRht d-none">
                <button
                  type="button"
                  onClick={() => {
                    onEdit(shippingAddressOriginal);
                  }}
                  className="a-tag-button text-decoration-underline fs-14 "
                  disabled={true}
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
